<template>
    <transition name="fade">
        <div class="modal modal-background" :class="{ 'is-processing': isProcessing }" v-if="data">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="text-body mb-0" v-html="data.message"></p>
                </div>
                <div class="modal-footer">
                    <div class="buttons mt-4">
                        <button type="button" class="btn cancel" @click="onCancel">Odustani</button>
                        <button type="button"
                                class="btn btn-success ml-20 flex pl-8" @click="onConfirm" :disabled="isProcessing">
                                <img src="/svg/confirm.svg" alt="confirm" class="mr-3 h-4 w-4">
                                Potvrdi
                        </button>
                    </div>
                </div>

                <div class="modal-loading">
                    <loading></loading>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Loading from './Loading'
import Form from '../core/Form'

export default {
    components: {
        Loading,
    },

    data() {
        return {
            data: null,
            isProcessing: false,
            form: null
        }
    },

    mounted() {
        Bus.$on('confirmModal', (data) => {
            let route = data.route,
                message = data.message || 'Are you sure you want to execute selected action?'

            console.log('Set data')
            console.log(data)

            this.form = new Form(data.params)

            this.data = {
                method: data.method || 'post',
                route: route,
                message: message,
            }
        })
    },

    methods: {
        onCancel() {
            this.data = null
        },

        onConfirm() {
            this.isProcessing = true

            this.form[this.data.method](this.data.route)
                .then(response => {
                    console.log('RESPONSE')
                    console.log(response)
                    // location.reload()

                    Bus.$emit('onSuccess', response)

                    this.$nextTick(() => {
                        this.data = null
                        this.form = null
                        this.isProcessing = false

                        Bus.$emit('onResolve')
                    })
                })
                .catch(error => {
                    Bus.$emit('onFailure', error)

                    this.isProcessing = false
                })
        }
    }
}
</script>
